// @ts-nocheck
import { createCommissionTemplate } from './commissionTemplateHelpers.js';

export default createCommissionTemplate({
  pharmaceuticalCompanyName: '유니메드제약',
  targetSheetName: '전제품수수료율-경구',
  headerRowIndex: 5,
  headerRowCount: 1,
  dataStartRowIndex: 6,
  columnMapping: {
    drugCode: '보험코드',
    commissionRate: '요율',
  },
  requiredHeaders: [
    '순번',
    '분류',
    '세분류',
    '주요성분',
    '주요성분(영문)',
    '유니메드 제품명',
    '요율',
    '기준가',
    '구분',
    '완료',
    '대조약/중요사항',
    '보험코드',
  ],
});
